import { render, staticRenderFns } from "./DashboardSidebarFooter.vue?vue&type=template&id=2a95bb63&scoped=true"
import script from "./DashboardSidebarFooter.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarFooter.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebarFooter.vue?vue&type=style&index=0&id=2a95bb63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a95bb63",
  null
  
)

export default component.exports